// client/src/components/shared/ScreenState.js
// Écran plein de transition : chargement, redirection, erreur.
import React from 'react';
import { LOGO_ICON } from './BrandLogo';

export default function ScreenState({ title, text, variant = 'loading', actionLabel, onAction }) {
  const isError = variant === 'error';
  return (
    <div className="eb-screen" role={isError ? 'alert' : 'status'} aria-live="polite">
      <div className="eb-screen__panel eb-fade-up">
        <img src={LOGO_ICON} alt="Ecobill" className="eb-screen__logo" />
        {!isError && <div className="eb-spinner" aria-hidden="true" />}
        {title ? <h1 className="eb-screen__title">{title}</h1> : null}
        {text ? <p className="eb-screen__text">{text}</p> : null}
        {actionLabel && onAction ? (
          <button type="button" className="eb-btn eb-btn--primary eb-btn--lg" onClick={onAction}>
            {actionLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}
